import * as React from 'react';
import { Label } from '@fluentui/react/lib/Label';
import { Select } from 'formComponents/Select/Select';
import { ValueType } from 'react-select';
import { SelectOption } from 'formComponents/Select/types';
import { MenuPlacement } from 'react-select/src/types';
import { useSelector } from 'react-redux';
import { einheitenByCodeSelector, einheitenSelector } from 'store/lookups/selector';
import { formStyles } from 'styles/formStyles';

interface EinheitByCodeProps {
    label: string;
    disabled: boolean;
    value: string | null;
    menuPlacement?: MenuPlacement;
    allowEmpty?: boolean;
    renderLabel?: 'label' | 'placeholder' | 'no';
    onChange: (newValue: string) => void;
}

export const EinheitByCode: React.FC<EinheitByCodeProps> = ({
    label,
    value,
    disabled,
    menuPlacement = 'bottom',
    allowEmpty = false,
    renderLabel = 'label',
    onChange,
}) => {
    const einheiten = useSelector(einheitenSelector);
    const einheitenByCode = useSelector(einheitenByCodeSelector);

    const options = React.useMemo(() => {
        const o = einheiten
            .sort((a, b) => a.text.localeCompare(b.text))
            .map((ag) => ({
                value: ag.code,
                label: ag.text,
            }));

        if (allowEmpty) {
            o.push({ value: '', label: '' });
        }

        return o;
    }, [einheiten, allowEmpty]);

    return (
        <>
            {renderLabel === 'label' && <Label className={disabled ? formStyles.labelDisabled : ''}>{label}</Label>}
            <Select
                name={label}
                isDisabled={disabled}
                isClearable={allowEmpty}
                value={
                    value
                        ? {
                              value: value.toString(),
                              label: einheitenByCode[value]?.text || value.toString(),
                          }
                        : {
                              value: '',
                              label: '',
                          }
                }
                options={options}
                menuPlacement={menuPlacement}
                onChange={(option: ValueType<SelectOption, false>): void => {
                    onChange(option?.value || '');
                }}
                placeholder={renderLabel === 'placeholder' ? 'Einheit' : ''}
            />
        </>
    );
};
